module.exports = __webpack_public_path__ + "img/gal-10.2b136576.jpg";